module.exports = __webpack_public_path__ + "img/edit_icon.c07104b5.svg";